
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieCredenzialiDialog extends Serenity.EntityDialog<TipologieCredenzialiRow, any> {
        protected getFormKey() { return TipologieCredenzialiForm.formKey; }
        protected getIdProperty() { return TipologieCredenzialiRow.idProperty; }
        protected getLocalTextPrefix() { return TipologieCredenzialiRow.localTextPrefix; }
        protected getNameProperty() { return TipologieCredenzialiRow.nameProperty; }
        protected getService() { return TipologieCredenzialiService.baseUrl; }
        protected getDeletePermission() { return TipologieCredenzialiRow.deletePermission; }
        protected getInsertPermission() { return TipologieCredenzialiRow.insertPermission; }
        protected getUpdatePermission() { return TipologieCredenzialiRow.updatePermission; }

        protected form = new TipologieCredenzialiForm(this.idPrefix);

    }
}